"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _droppable_definition = _interopRequireDefault(require("./droppable_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* ========== ~~~~~~~~~~ EXPORT : DROPPABLE ~~~~~~~~~~ ========== */


var Droppable = function Droppable(_ref) {
  var klass = _ref.klass,
      droppableId = _ref.droppableId,
      direction = _ref.direction,
      elements = _ref.elements;
  return _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: droppableId,
    direction: direction
  }, function (provided, snapshot) {
    return _react.default.createElement("div", {
      className: "".concat(klass, " droppable isDraggingOver-").concat(!!snapshot.isDraggingOver),
      ref: provided.innerRef
    }, elements.map(function (elementBlob, idx) {
      return _react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: idx,
        draggableId: "".concat(elementBlob.id),
        index: elementBlob.position
      }, function (provided, snapshot) {
        return _react.default.createElement("div", _extends({
          className: "draggable isDragging-".concat(snapshot.isDragging),
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), elementBlob.element, provided.placeholder);
      });
    }));
  });
};
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(Droppable, _droppable_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Droppable;
exports.default = _default;